import { Tooltip } from "@material-ui/core";
import AccountBalanceTwoToneIcon from "@material-ui/icons/AccountBalanceTwoTone";
import AccountBalanceWalletTwoToneIcon from "@material-ui/icons/AccountBalanceWalletTwoTone";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CodeTwoToneIcon from "@material-ui/icons/CodeTwoTone";
import CreditCardTwoToneIcon from "@material-ui/icons/CreditCardTwoTone";
import DoneAllTwoToneIcon from "@material-ui/icons/DoneAllTwoTone";
import NewReleasesTwoToneIcon from "@material-ui/icons/NewReleasesTwoTone";
import PostAddTwoToneIcon from "@material-ui/icons/PostAddTwoTone";
import LockIcon from "@material-ui/icons/Lock";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CreateIcon from "@material-ui/icons/Create";
import React from "react";
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';

export const getLabel = (list, data) => {
  const newObject = list.filter(function (item) {
    return item.value === data;
  });
  if (newObject.length === 0) {
    return "N/A";
  }
  return newObject[0].label;
};

export const getSecondValue = (list, data) => {
  const newObject = list.filter(function (item) {
    return item.value === data;
  });
  if (newObject.length === 0) {
    return "N/A";
  }
  return newObject[0].value2;
};

export const getIconByLabel = (list, data) => {
  const newObject = list.filter(function (item) {
    return item.label === data;
  });
  if (newObject.length === 0) {
    return "N/A";
  }
  return newObject[0].icon;
};

export const getObjectByValue = (list, data) => {
  // console.log(data);
  const newObject = list.filter(function (item) {
    return item.value === data;
  });
  if (newObject.length === 0) {
    return null;
  }
  return newObject[0];
};

export const dateTimeOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
};

export const dateOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
};

export const billTypes = [
  // { "value": "BILL", "label": "Számla", "icon": <Tooltip title="Számla"><span className="char-icon">{'S'}</span></Tooltip> },
  {
    value: "BILL",
    label: "Számla",
    icon: <span className="char-icon">{"S"}</span>,
  },
  {
    value: "PROFORMA",
    label: "Díjbekérő",
    icon: <span className="char-icon">{"D"}</span>,
  },
  {
    value: "PREPAYMENT",
    label: "Előlegszámla",
    icon: <span className="char-icon">{"E"}</span>,
  },
  {
    value: "FINAL_BILL",
    label: "Végszámla",
    icon: <span className="char-icon">{"V"}</span>,
  },
];

export const partnerForBillTypes = [
  { value: "SUPPLIER", label: "Beszállító" },
  { value: "BUYER", label: "Vevő" },
  { value: "BOTH", label: "Mindkettő" },
];

export const projectBillingTypes = [
  { value: "MONTHLY", label: "Havi" },
  { value: "CUSTOM", label: "Egyéni" },
];

export const partnerTypes = [
  { value: "SUPPLIER", label: "Beszállító" },
  { value: "BUYER", label: "Vevő" },
  { value: "BOTH_BILL_PARTNER", label: "Partner" },
  { value: "TAX_TYPE", label: "Adónem" },
  { value: "EMPLOYEE", label: "Munkavállaló" },
  { value: "RESTRAIN_PARTNER", label: "Letiltás partner" },
];

export const partnerTypesForCorrection = [
  { value: "SUPPLIER", label: "Beszállító" },
  { value: "BUYER", label: "Vevő" },
  { value: "BOTH_BILL_PARTNER", label: "Partner" },
  { value: "TAX_TYPE", label: "Adónem" },
  { value: "EMPLOYEE", label: "Munkavállaló" },
  { value: "RESTRAIN_PARTNER", label: "Letiltás partner" },
  { value: "CASH", label: "Készpénz" },
];

export const currencies = [
  { value: "HUF", label: "ft" },
  { value: "EUR", label: "eur" },
];

export const outPaymentMethods = [
  { value: "CASH", label: "Készpénz" },
  { value: "WIRE", label: "Utalás" },
];

export const paymentMethods = [
  {
    value: "CASH",
    label: "Készpénz",
    icon: (
      <Tooltip title="Készpénz">
        <AccountBalanceWalletTwoToneIcon color="primary" />
      </Tooltip>
    ),
  },
  {
    value: "WIRE",
    label: "Utalás",
    icon: (
      <Tooltip title="Utalás">
        <AccountBalanceTwoToneIcon color="primary" />
      </Tooltip>
    ),
  },
  {
    value: "CREDIT_CARD",
    label: "Bankkártya",
    icon: (
      <Tooltip title="Bankkártya">
        <CreditCardTwoToneIcon color="primary" />
      </Tooltip>
    ),
  },
];

export const states = [
  {
    value: "RECEIVED",
    label: "Importálva",
    icon: (
      <Tooltip title="Importálva">
        <CloudDownloadIcon />
      </Tooltip>
    ),
  },
  {
    value: "NEW",
    label: "Új",
    icon: (
      <Tooltip title="Új">
        <PostAddTwoToneIcon />
      </Tooltip>
    ),
  },
  { value: "WIRED", label: "Átutalva" },
  {
    value: "MATCH_FOUND",
    label: "Tranzakció találat",
    icon: (
      <Tooltip title="Tranzakció találat">
        <NewReleasesTwoToneIcon />
      </Tooltip>
    ),
  },
  {
    value: "INCOMPLETE",
    label: "Részlegesen fizetve",
    icon: (
      <Tooltip title="Részlegesen fizetve">
        <CodeTwoToneIcon />
      </Tooltip>
    ),
  },
  {
    value: "PAID",
    label: "Fizetve",
    icon: (
      <Tooltip title="Fizetve">
        <DoneAllTwoToneIcon />
      </Tooltip>
    ),
  },
  {
    value: "CLOSED",
    label: "Lezárva",
    icon: (
      <Tooltip title="Lezárva">
        <LockIcon />
      </Tooltip>
    ),
  },
  {
    value: "DRAFT",
    label: "Piszkozat",
    icon: (
      <Tooltip title="Piszkozat">
        <CreateIcon />
      </Tooltip>
    ),
  },
];

export const transactionStates = [
  {
    value: "NEW",
    label: "Új",
    icon: (
      <Tooltip title="Új">
        <PostAddTwoToneIcon />
      </Tooltip>
    ),
  },
  { value: "WIRED", label: "Átutalva" },
  {
    value: "MATCH_FOUND",
    label: "Számla találat",
    icon: (
      <Tooltip title="Tranzakció találat">
        <NewReleasesTwoToneIcon />
      </Tooltip>
    ),
  },
  {
    value: "INCOMPLETE",
    label: "Befejezetlen",
    icon: (
      <Tooltip title="Részlegesen fizetve">
        <CodeTwoToneIcon />
      </Tooltip>
    ),
  },
  {
    value: "COMPLETE",
    label: "Kész",
    icon: (
      <Tooltip title="Fizetve">
        <DoneAllTwoToneIcon />
      </Tooltip>
    ),
  },
  {
    value: "CLOSED",
    label: "Lezárva",
    icon: (
      <Tooltip title="Lezárva">
        <DoneAllTwoToneIcon />
      </Tooltip>
    ),
  },
];

export const projectStates = [
  {
    value: "ACTIVE",
    label: "Aktív",
    icon: (
      <Tooltip title="Aktív">
        <CheckCircleOutlineIcon />
      </Tooltip>
    ),
  },
  {
    value: "PENDING",
    label: "Nyitott ütemek",
    icon: (
      <Tooltip title="Nyitott ütemek">
        <PauseCircleOutlineIcon />
      </Tooltip>
    ),
  },
  {
    value: "INACTIVE",
    label: "Inaktív",
    icon: (
      <Tooltip title="Inaktív">
        <CancelOutlinedIcon />
      </Tooltip>
    ),
  },
];

export const balanceRowTypes = [
  { value: "PAYING_WITH_CARD", label: "Bankkártyás fizetés" },
  { value: "WIRE", label: "Utalás" },
  { value: "CORRECTION_FIX", label: "Fix korrekció" },
  { value: "CORRECTION_MODIFY", label: "Módosító korrekció" },
  { value: "BILL", label: "Számla" },
  { value: "FINAL_BILL", label: "Végszámla" },
  { value: "PROFORMA", label: "Díjbekérő" },
  { value: "PREPAYMENT", label: "Előlegszámla" },
  { value: "PREFILL", label: "Előírás" },
  { value: "TAX_TRANSITION", label: "Adó átvezetés" },
];

export const owingTypes = [
  { value: "SALARY", label: "Munkadíj átutalás" },
  { value: "INCOMING_BILL", label: "Bejövő számla átutalás" },
  { value: "TAX", label: "Adó átutalás" },
  { value: "RESTRAIN", label: "Letiltás átutalás" },
  { value: "DIVIDEND", label: "Osztalék átutalás" },
];

export const correctionTypes = [
  { value: "FIX", label: "Fix" },
  { value: "MODIFY", label: "Módosít" },
];

export const pettyCashTypes = [
  { value: "CASH_WITHDRAWAL_FROM_ATM", label: "Készpénzfelvét ATM-ből" },
  { value: "OCCASIONAL_SALARY", label: "Alkalmi munkadíj" },
  { value: "CASH_SALARY", label: "Készpénzes munkadíj" },
  { value: "INCOMING_BILL", label: "Bejövő számla" },
  { value: "OUTGOING_BILL", label: "Kimenő számla" },
  { value: "CORRECTION_FIX", label: "Fix korrekció" },
  { value: "CORRECTION_MODIFY", label: "Módosító korrekció" },
];

export const transactionTypes = [
  { value: "PAYING_WITH_CARD", label: "VÁSÁRLÁS KÁRTYÁVAL" },
  { value: "IN_DAY_WIRE", label: "NAPKÖZBENI ÁTUTALÁS" },
  { value: "IMMEDIATE_WIRE", label: "AZONNALI ÁTUTALÁS" },
  { value: "IMMEDIATE_WIRE_INSIDE_BANK", label: "AZONNALI ÁTUTALÁS BANKON BELÜL" },
  { value: "QVIK_WIRE_INSIDE_BANK", label: "QVIK ÁTUTALÁS BANKON BELÜL" },
  { value: "QVIK_WIRE", label: "QVIK ÁTUTALÁS" },
  { value: "CASH_WITHDRAWAL_FROM_ATM", label: "KÉSZPÉNZFELVÉT ATM-BŐL" },
  { value: "MESSAGE_FEE", label: "OTPdirekt ÜZENETDÍJ" },
  { value: "WITHDRAWAL_FEE", label: "KP.FELVÉT/-BEFIZ. DÍJA" },
  { value: "PERIODIC_FEES", label: "IDŐSZAKOS KÖLTSÉGEK" },
  { value: "TRAFFIC_HOUSE_CHARGE", label: "FORGALMI KÜLÖNDÍJ" },
  { value: "INTEREST", label: "KAMATJÓVÁÍRÁS" },
  { value: "MONTHLY_FEE", label: "HAVI ZÁRLATI DÍJ" },
  { value: "TECHNICAL_TRANSACTION", label: "TECHNIKAI TRANZAKCIÓ" },
  { value: "GENERAL_FEES", label: "VEGYES SZÁMLAKÖLTSÉGEK" },
  { value: "FEE_AND_COMMISSION", label: "KÖLTSÉG ÉS JUTALÉK" },
];

export const simpleTransactionTypes = [
  { value: "PAYING_WITH_CARD", label: "VÁSÁRLÁS KÁRTYÁVAL" },
  { value: "WIRE", label: "UTALÁS" },
  { value: "CASH_WITHDRAWAL_FROM_ATM", label: "KÉSZPÉNZFELVÉT" },
  { value: "FEE", label: "DÍJ" },
  { value: "INTEREST", label: "JÓVÁÍRÁS" },
];

export const transactionSides = [
  { value: "IN", label: "BE" },
  { value: "OUT", label: "KI" },
];

export const activeStates = [
  {
    value: true,
    value2: "ACTIVE",
    label: "Aktív",
    icon: (
      <Tooltip title="Aktív">
        <CheckCircleOutlineIcon />
      </Tooltip>
    ),
  },
  {
    value: false,
    value2: "INACTIVE",
    label: "Inaktív",
    icon: (
      <Tooltip title="Inaktív">
        <CancelOutlinedIcon />
      </Tooltip>
    ),
  },
];

export const taxTypes = [
  { value: "MONTHLY", label: "Havi" },
  { value: "QUARTERLY", label: "Negyedévi" },
  { value: "BIANNUAL", label: "Félévi" },
  { value: "ANNUAL", label: "Évi" },
];

export const objectTypes = [
  { value: "TAX", label: "Adó" },
  { value: "INCOMING_BILL", label: "Bejövő számla" },
  { value: "OUTGOING_BILL", label: "Kimenő számla" },
  { value: "SALARY", label: "Fizetés" },
  { value: "TRANSACTION", label: "Tranzakció" },
  { value: "RESTRAIN", label: "Letiltás" },
];

export const pluralObjectTypes = [
  { value: "TAX", label: "adók" },
  { value: "INCOMING_BILL", label: "bejövő számlák" },
  { value: "OUTGOING_BILL", label: "kimenő számlák" },
  { value: "SALARY", label: "fizetések" },
  { value: "TRANSACTION", label: "tranzakciók" },
  { value: "RESTRAIN", label: "letiltások" },
];

export const closeTypes = [
  { value: "CLOSE", label: "Lezárás" },
  { value: "REOPEN", label: "Újranyitás" },
];

export const highestSchool = [
  { value: "NONE", label: "Nincs" },
  { value: "ELEMENTARY", label: "8 Általános" },
  { value: "HIGH_SCHOOL", label: "Érettségi" },
  { value: "BSC_DIPLOMA", label: "Főiskola" },
  { value: "MSC_DIPLOMA", label: "Egyetem" },
];

export const trueFalse = [
  { value: "null", label: "\xAD" },
  { value: "true", label: "Igen" },
  { value: "false", label: "Nem" },
];

export const trueFalseHaving = [
  { value: "null", label: "\xAD" },
  { value: "true", label: "Van" },
  { value: "false", label: "Nincs" },
];

export const vacationTypes = [
  { value: "VACATION", label: "Szabadság" },
  { value: "SICK_LEAVE", label: "Betegszabadság" },
  { value: "GOV_PAID_SICK_LEAVE", label: "Táppénz" },
  { value: "LEAVE_WITHOUT_PAY", label: "Fizetetlen szabadság" },
];

export const employeeTypes = [
  { value: "FULL_TIME", label: "Állandó" },
  { value: "OCCASIONAL", label: "Alkalmi" },
];

export const driverLicenses = [
  { value: true, label: "Van" },
  { value: false, label: "Nincs" },
];

export const insuranceTypes = [
  { value: "LIABILITY", label: "Kötelező biztosítás" },
  { value: "CASCO", label: "CASCO" },
];

export const billingTypes = [
  { value: "MONTHLY", label: "Havi" },
  { value: "CUSTOM", label: "Egyéni" },
];

export const projectPhaseStates = [
  { value: "UNDER_CONSTRUCTION", label: "Építés alatt" },
  { value: "UNDER_RENTAL", label: "Bérbeadás alatt" },
  { value: "UNDER_DISMANTLING", label: "Bontás alatt" },
  { value: "DISMANTLED", label: "Lebontva" },
  { value: "SURVEY_LOG_READY", label: "Felmérési napló kész" },
  { value: "SURVEY_LOG_SENT_AWAITING_CONFIRMATION", label: "Felmérési napló visszaigazolásra vár" },
  { value: "SURVEY_LOG_CONFIRMED", label: "Felmérési napló visszaigazolva" },
  { value: "INVOICE_ISSUED_SENT", label: "Számla elküldve" },
  { value: "INVOICE_PAID", label: "Számla kiegyenlítve" },
  { value: "WAITING", label: "Várakozás" }
];

export const projectPhaseEvents = [
  // { value: "RENTAL_STARTED_EVENT", label: "Bérbeadás elkezdődött" },
  { value: "CONSTRUCTION_STARTED_EVENT", label: "Építés elkezdődött" },
  { value: "CONSTRUCTION_DONE_EVENT", label: "Építés befejeződött" },
  { value: "DISMANTLE_STARTED_EVENT", label: "Bontás elkezdődött" },
  { value: "DISMANTLE_DONE_EVENT", label: "Bontás befejeződött" },
  { value: "RENTAL_FINISHED_EVENT", label: "Bérbeadás befejeződött" },
  { value: "SURVEY_LOG_READY_EVENT", label: "Felmérési napló kész" },
  { value: "SURVEY_LOG_SENT_EVENT", label: "Felmérési napló elküldve" },
  { value: "SURVEY_LOG_CONFIRMED_EVENT", label: "Felmérési napló visszaigazolva" },
  { value: "INVOICE_ISSUED_SENT_EVENT", label: "Leszámlázva" },
  { value: "INVOICE_PAID_EVENT", label: "Számla teljesítve" }
];


